import { useTranslations } from 'next-intl'

import { TRoomDetail } from '@/entities/room'
import { ContentBox } from '@/shared/ui'
import { RefundTermNotice, useRefundTerm } from '@/widgets/contract-detail'

import { Heading, Item, List } from '../common'

type Props = Pick<TRoomDetail, 'refundTerms'> & {
  isOldRefundTerms?: boolean
}

export const RefundTerm = ({
  refundTerms,
  isOldRefundTerms = false,
}: Props) => {
  const t = useTranslations()

  const { getDiffDayText, getPenaltyText } = useRefundTerm()

  return (
    <section>
      <Heading className="mb-4">{t('room_detail.refund_policy.title')}</Heading>

      <div>
        <div className="typo-label2 mb-4 flex items-center justify-between font-medium text-gray-500">
          <span>{t('refund_policy.label.cancel_date')}</span>
          <span>{t('refund_policy.label.penalty')}</span>
        </div>

        <List
          spacing="small"
          variant="dashed"
          borderColor="gray"
          className="mb-5"
        >
          {refundTerms.map(refundTerm => (
            <Item
              key={refundTerm.beforeCheckinDays}
              className="typo-label2 flex items-center justify-between font-normal text-gray-900"
            >
              <span>{getDiffDayText(refundTerm.beforeCheckinDays)}</span>
              <span>
                {getPenaltyText(refundTerm.cancelFeePercent, isOldRefundTerms)}
              </span>
            </Item>
          ))}
        </List>

        <ContentBox color="light-gray" spacing="medium" className="py-5">
          <RefundTermNotice
            isOldRefundTerms={isOldRefundTerms}
            className="px-0"
          />
        </ContentBox>
      </div>
    </section>
  )
}
